import { z } from 'zod';
import { xmlValueSchema } from '../xml-value-schema';

const nmiStandingData = z
  .object({
    NMI: z.object({
      _attributes: z.object({
        checksum: z.string(),
      }),
      _text: z.string(),
    }),
    MasterData: z.object({
      Address: z.object({
        StructuredAddress: z.object({
          House: z.object({
            HouseNumber: xmlValueSchema,
          }),
          Street: z.object({
            StreetName: xmlValueSchema,
            StreetType: xmlValueSchema,
          }),
        }),
        SuburbOrPlaceOrLocality: xmlValueSchema,
        StateOrTerritory: xmlValueSchema,
        PostCode: xmlValueSchema,
        DeliveryPointIdentifier: xmlValueSchema,
        GNAFPID: xmlValueSchema,
      }),
      CustomerClassificationCode: xmlValueSchema,
      CustomerThresholdCode: xmlValueSchema,
      SharedIsolationPointFlag: xmlValueSchema,
      ConnectionConfiguration: xmlValueSchema,
    }),
  })
  .transform((value) => {
    return {
      nmi: value.NMI._text,
      checksum: value.NMI._attributes.checksum,
      address: {
        houseNumber:
          value.MasterData.Address.StructuredAddress.House.HouseNumber,
        streetName:
          value.MasterData.Address.StructuredAddress.Street.StreetName,
        streetType:
          value.MasterData.Address.StructuredAddress.Street.StreetType,
        suburbOrPlaceOrLocality:
          value.MasterData.Address.SuburbOrPlaceOrLocality,
        stateOrTerritory: value.MasterData.Address.StateOrTerritory,
        postcode: value.MasterData.Address.PostCode,
        deliveryPointIdentifier:
          value.MasterData.Address.DeliveryPointIdentifier,
        gnafpid: value.MasterData.Address.GNAFPID,
      },
      customerClassificationCode: value.MasterData.CustomerClassificationCode,
      customerThresholdCode: value.MasterData.CustomerThresholdCode,
      sharedIsolationPointFlag: value.MasterData.SharedIsolationPointFlag,
      connectionConfiguration: value.MasterData.ConnectionConfiguration,
    };
  });

export type NmiStandingData = z.infer<typeof nmiStandingData>;

const nmiStandingSource = z.preprocess((value) => {
  if (value instanceof Array) {
    return value as NmiStandingData[];
  }

  return [value];
}, z.array(nmiStandingData));

export const nmiSchema = z
  .object({
    'ase:aseXML': z.object({
      Transactions: z.object({
        Transaction: z.object({
          NMIDiscoveryResponse: z.object({
            NMIStandingData: nmiStandingSource.optional(),
          }),
        }),
      }),
    }),
  })
  .transform(
    (value) =>
      value['ase:aseXML'].Transactions.Transaction.NMIDiscoveryResponse
        .NMIStandingData ?? []
  );

export type NmiSchema = z.infer<typeof nmiSchema>;
